import logoImage from '@assets/images/logo_L.png'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLogin } from './hooks/useLogin'
import { LoadingOverlay } from '@/components/LoadingOverlay'
import { useAuth } from '@/context/AuthContext'
import { useAdminAccount } from '@/context/AdminAccountContext'
import Footer from '@components/Footer'

function Login() {
  const navigate = useNavigate()
  const { user, loading: authLoading } = useAuth()
  const { adminAccount, isLoading: adminAccountLoading } = useAdminAccount()
  const {
    email,
    setEmail,
    password,
    setPassword,
    showPassword,
    isLoading,
    emailError,
    passwordError,
    setEmailError,
    setPasswordError,
    handleSubmit,
    togglePasswordVisibility,
  } = useLogin()

  useEffect(() => {
    if (authLoading || adminAccountLoading) return

    if (user && adminAccount) {
      navigate('/dashboards', { replace: true })
    }
  }, [user, adminAccount, authLoading, adminAccountLoading, navigate])

  if (authLoading || adminAccountLoading) {
    return <LoadingOverlay show />
  }

  // ログイン直後の一時状態ではフォームを出さず待機（403ちらつき防止）
  if (user && !adminAccount) {
    return <LoadingOverlay show />
  }

  return (
    <div className="auth-page-shell">
      <div className="login-container">
        <LoadingOverlay show={isLoading} />
        <div className="login-card">
          <img src={logoImage} alt="IROGAMI" className="login-logo" />
          <form onSubmit={handleSubmit}>
            <div className={`form-group ${emailError ? 'has-error' : ''}`}>
              <label htmlFor="email">メールアドレス</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value)
                  if (emailError) setEmailError(null)
                }}
                placeholder="Email"
                autoComplete="email"
                className={emailError ? 'error' : ''}
              />
              {emailError && (
                <div className="field-error">
                  <i className="bi bi-exclamation-circle"></i>
                  <span>{emailError}</span>
                </div>
              )}
            </div>
            <div className={`form-group ${passwordError ? 'has-error' : ''}`}>
              <label htmlFor="password">パスワード</label>
              <div className="password-input-wrapper">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value)
                    if (passwordError) setPasswordError(null)
                  }}
                  placeholder="パスワード"
                  autoComplete="current-password"
                  className={passwordError ? 'error' : ''}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                  aria-label={showPassword ? 'パスワードを隠す' : 'パスワードを表示'}
                >
                  <i className={showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'}></i>
                </button>
              </div>
              {passwordError && (
                <div className="field-error">
                  <i className="bi bi-exclamation-circle"></i>
                  <span>{passwordError}</span>
                </div>
              )}
            </div>
            <button type="submit" className="login-button" disabled={isLoading}>
              {isLoading ? 'ログイン中...' : 'ログイン'}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Login
